import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { LockIcon, LockOpenIcon } from "@/shared/icons";
import { Icon } from "@/shared/ui";

type Props = {
  className?: string;
  isLock: boolean;
};

export default function EstateLockIcon({ isLock, className }: Props) {
  return (
    <div
      className={cn("flex items-center justify-center size-10.5 bg-white rounded-2xl", className)}
      style={{
        background: isLock
          ? "linear-gradient(135deg, rgba(215, 52, 52, 0.40) 0%, rgba(18, 18, 18, 0.00) 100%), rgba(18, 18, 18, 0.80)"
          : "rgba(18, 18, 18, 0.60)",
        backdropFilter: "blur(5px)",
      }}
    >
      {isLock ? (
        <LockIcon size={20} className="text-accent-solid" />
      ) : (
        <LockOpenIcon size={20} className="text-white" />
      )}
    </div>
  );
}
